import axios from 'axios';
import {REQUEST_URL} from '../config/urls';
import EmailServices from '../services/email';

const requisitar = () => {
  return {
    type: "REQUISITAR_USUARIO"
  };
}

const autenticou = (resposta) => {
  return {
    type: "AUTENTICOU",
    usuario: resposta.usuario,
    token: resposta.token.id
  }
}

const autenticouCookie = (usuario) => {
  return {
    type: "AUTENTICOU_COOKIE",
    usuario
  }
}

const erroAutenticacao = (message) => {
  return {
    type: "ERRO_AUTENTICACAO",
    message
  }
}

const erro = (erro) => {
  if(erro.statusCode===401){
    axios.defaults.headers.common['Authorization'] = "";
    return {
      type: "LOGOUT"
    }
  }else{
    return {
      type: "ERRO_USUARIO",
      erro
    }
  }
}

const obterTodos = (usuarios) => {
  return {
    type: "OBTER_TODOS_USUARIOS",
    usuarios
  }
}

const novoUsuario = (usuario) => {
  return {
    type: "NOVO_USUARIO",
    usuario
  }
}
const novoUsuarioFormando = (usuario) => {
  return {
    type: "NOVO_USUARIO_FORMANDO",
    usuario
  }
}

const alterarUsuario = (usuario) => {
  return {
    type: "ALTERAR_USUARIO",
    usuario
  }
}

const removerUsuario = (id) => {
  return {
    type: "REMOVER_USUARIO",
    id
  }
}

// FUNÇÕES EXPORTADAS

export const login = (credenciais) => {
  return dispatch => {
    dispatch(requisitar());
    return axios.post(`${REQUEST_URL}/usuarios/login`, credenciais).then(response => {
      let resposta = response.data;
      axios.defaults.headers.common['Authorization'] = resposta.token.id;
      localStorage.setItem('token', resposta.token.id);
      localStorage.setItem('tokenAlphaE', resposta.tokenAlphaE);
      localStorage.setItem('tokenMapaVendas', resposta.tokenMapaVendas);
      localStorage.setItem('tokenPagamento', resposta.tokenPagamento);
      localStorage.setItem('usuarioLogadoAdministracao', JSON.stringify(resposta.usuario));
      dispatch(autenticou(resposta));
    }).catch(error => {
      dispatch(erroAutenticacao(error.message));
    });
  }
}

export const setUsuario = (usuario) => {
  return dispatch => {
    dispatch(autenticouCookie(usuario));
  }
}

export const logout = () => {
  axios.defaults.headers.common['Authorization'] = "";
  localStorage.clear();
  return {
    type: "LOGOUT"
  }
}

export const adicionarUsuario = (usuario) => {
  return dispatch => {
    dispatch(requisitar());
    return axios.post(`${REQUEST_URL}/usuarios`, usuario).then((response) => {
      dispatch(novoUsuario(response.data));
    }).catch(error => {
      dispatch(erro(error.response.data.error));
    });
  }
}

export const adicionarUsuarioFormando = (formando) => {
  let usuario = {
    login: formando.email,
    senha: Math.random().toString(36).slice(-8),
    nome: formando.nome,
    tipo: 'formando',
    email: formando.email
  }
  return dispatch => {
    dispatch(requisitar());
    return axios.post(`${REQUEST_URL}/usuarios`, usuario).then((response) => {
      axios.post(`${REQUEST_URL}/formandos/update?where={"id": ${formando.id}}`, {usuario: response.data.id}).then(() => {
        new EmailServices().enviar("formando", {usuario: {nome: usuario.nome , email: usuario.email, senha: usuario.senha}}, false);
      }).catch(error => {
        dispatch(erro(error.response.data.error));
      });
      dispatch(novoUsuarioFormando(response.data));
    }).catch(error => {
      dispatch(erro(error.response.data.error));
    });
  }
}

export const editarUsuario = (usuario, id) => {
  return dispatch => {
    dispatch(requisitar());
    return axios.patch(`${REQUEST_URL}/usuarios/${id}`, usuario).then((response) => {
      dispatch(alterarUsuario(response.data));
    }).catch(error => {
      dispatch(erro(error.response.data.error));
    });
  }
}

export const deletarUsuario = (id) => {
  return dispatch => {
    dispatch(requisitar());
    return axios.delete(`${REQUEST_URL}/usuarios/${id}`).then(() => {
      dispatch(removerUsuario(id));
    }).catch(error => {
      dispatch(erro(error.response.data.error));
    });
  }
}

export const obterUsuarios = () => {
  return dispatch => {
    dispatch(requisitar());
    return axios.get(`${REQUEST_URL}/usuarios`).then((response) => {
      dispatch(obterTodos(response.data));
    }).catch(error => {
      dispatch(erro(error.response.data.error));
    });
  }
}

export const obterUsuariosAdministracao = () => {
  return dispatch => {
    dispatch(requisitar());
    return axios.get(`${REQUEST_URL}/usuarios?filter={"where":{"or":[{"tipo":"administrador"},{"tipo":"comum"}]}}`).then((response) => {
      dispatch(obterTodos(response.data));
    }).catch(error => {
      dispatch(erro(error.response));
    });
  }
}

export const obterUsuariosVinculadosAoMetrics = () => {
  return dispatch => {
    dispatch(requisitar());
    return axios.get(`${REQUEST_URL}/usuarios?filter={"where":{"idResponsavel": {"gt": 0}}}`).then((response) => {
      dispatch(obterTodos(response.data));
    }).catch(error => {
      dispatch(erro(error.response));
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/UsuarioActions.js